import mitt from 'mitt';

const emitter = mitt();

const useEmitter = () => emitter;

export default useEmitter;
